import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { ButtonProps } from '../../types';
import Typography from '@/components/atoms/typography';

const ButtonElement = ({ onOpen, item }: ButtonProps) => {
  
  return (
    <div
      className="flex cursor-pointer items-center !font-[600] justify-center text-[14px] !leading-[19px] text-[#191919] py-[0.28rem] pl-1 pr-2.5 rounded-[100px] bg-[#F8F8F8] gap-2"
      onClick={onOpen}
    >
   
      <div className="w-[30px] h-[30px] rounded-[100px] flex items-center justify-center bg-black">
        <Typography className="text-16 leading-normal font-normal    text-[14px] !leading-[19px] text-white !font-[600]">
          {item?.charAt(0)?.toUpperCase() || 'M'}
        </Typography>
      </div>

      <div className='flex items-center gap-x-1'>
        <Typography className="text-16 leading-normal font-normal    text-[14px] !leading-[19px] text-[#191919] !font-[600]">
          {item || 'My Account'}
        </Typography>
      </div>
      <ChevronDownIcon className=" h-[1.15rem] w-[1.15rem] text-black" />
    </div>
  );
};

export default ButtonElement;
